import BaseEndpoint from './BaseEndpoint';
import TrustUpIOTask from '@spa/apps/trustup-pro-base-js/models/TrustUpIOTask';
import TrustUpIOTaskCollection from '@spa/apps/trustup-pro-base-js/collections/TrustUpIOTaskCollection';

export default class TrustUpIOTaskEndpoint extends BaseEndpoint
{

    constructor()
    {
        super(
            'trustup-io-task',
            {
                'path': 'tasks',
                'responseKey': 'data',
                'responseKeyPlural': 'tasks',
                'modelClass': TrustUpIOTask,
                'collectionClass': TrustUpIOTaskCollection
            }
        );
    }

    withCredentials()
    {
        return false;
    }

    getUrl()
    {
        return 'https://tasks.trustup.io';
    }

    async store(data)
    {
        return await super.store({task: data});
    }

    async update({uuid, data, url = null})
    {
        return await super.update({uuid, data: {task: data}, url});
    }

}